/* ==========================================================================
   Earthly Nature — global.js
   Vanilla JS. No dependencies. Everything is delegated and re-initialisable
   so it survives Shopify theme-editor section reloads.
   ========================================================================== */

(function () {
  'use strict';

  var EN = window.EarthlyNature || {};
  var routes = EN.routes || {};
  var body = document.body;

  /* ------------------------------------------------------------------ utils */

  function $(sel, root) {
    return (root || document).querySelector(sel);
  }

  function $$(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  function formatMoney(cents) {
    var format = EN.moneyFormat || '${{amount}}';
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var withCommas = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');

    return format
      .replace(/\{\{\s*amount\s*\}\}/g, withCommas + '.' + parts[1])
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, withCommas)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1])
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.'));
  }

  function debounce(fn, wait) {
    var t;
    return function () {
      var args = arguments;
      var ctx = this;
      clearTimeout(t);
      t = setTimeout(function () {
        fn.apply(ctx, args);
      }, wait);
    };
  }

  function trapFocus(container) {
    var focusables = $$(
      'a[href], button:not([disabled]), input:not([type="hidden"]):not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])',
      container
    ).filter(function (el) {
      return el.offsetParent !== null;
    });
    if (!focusables.length) return;
    focusables[0].focus();
  }

  /* ------------------------------------------------------- overlay + drawers */

  var openDrawers = [];

  function getOverlay() {
    return $('[data-overlay]');
  }

  function lockScroll(lock) {
    body.classList.toggle('is-locked', lock);
  }

  function openDrawer(id) {
    var drawer = document.getElementById(id);
    if (!drawer) return;

    drawer.hidden = false;
    // Force reflow so the transition runs from the hidden state.
    void drawer.offsetWidth;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');

    var overlay = getOverlay();
    if (overlay) {
      overlay.hidden = false;
      void overlay.offsetWidth;
      overlay.classList.add('is-visible');
    }

    lockScroll(true);
    if (openDrawers.indexOf(id) === -1) openDrawers.push(id);
    setTimeout(function () {
      trapFocus(drawer);
    }, 60);
  }

  function closeDrawer(id) {
    var drawer = id ? document.getElementById(id) : null;
    var targets = drawer ? [drawer] : $$('.drawer.is-open, .search-drawer.is-open');

    targets.forEach(function (el) {
      el.classList.remove('is-open');
      el.setAttribute('aria-hidden', 'true');
      setTimeout(function () {
        if (!el.classList.contains('is-open')) el.hidden = true;
      }, 260);
      var i = openDrawers.indexOf(el.id);
      if (i > -1) openDrawers.splice(i, 1);
    });

    if (!$$('.drawer.is-open, .search-drawer.is-open').length) {
      var overlay = getOverlay();
      if (overlay) {
        overlay.classList.remove('is-visible');
        setTimeout(function () {
          if (!overlay.classList.contains('is-visible')) overlay.hidden = true;
        }, 260);
      }
      lockScroll(false);
    }
  }

  document.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-drawer-open]');
    if (opener) {
      event.preventDefault();
      openDrawer(opener.getAttribute('data-drawer-open'));
      return;
    }

    var closer = event.target.closest('[data-drawer-close]');
    if (closer) {
      event.preventDefault();
      var explicit = closer.getAttribute('data-drawer-close');
      closeDrawer(explicit || null);
      return;
    }

    if (event.target.matches('[data-overlay]')) {
      closeDrawer();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeDrawer();
  });

  window.ENDrawer = { open: openDrawer, close: closeDrawer };

  /* ------------------------------------------------------------ mobile menu */

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-submenu-toggle]');
    if (!toggle) return;
    event.preventDefault();
    var panel = toggle.nextElementSibling;
    if (!panel) return;
    var isOpen = panel.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
  });

  /* --------------------------------------------------------- sticky header */

  function initStickyHeader() {
    var wrap = $('[data-header-wrap]');
    if (!wrap) return;

    var onScroll = function () {
      wrap.classList.toggle('is-stuck', window.scrollY > 8);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* -------------------------------------------------------- search drawer */

  document.addEventListener('click', function (event) {
    if (!event.target.closest('[data-drawer-open="SearchDrawer"]')) return;
    setTimeout(function () {
      var input = $('#SearchDrawer input[type="search"]');
      if (input) input.focus();
    }, 120);
  });

  /* -------------------------------------------------------- quantity input */

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-qty-change]');
    if (!btn) return;
    event.preventDefault();

    var wrap = btn.closest('.qty');
    var input = $('input', wrap);
    if (!input) return;

    var step = btn.getAttribute('data-qty-change') === 'up' ? 1 : -1;
    var min = parseInt(input.getAttribute('min') || '1', 10);
    var next = (parseInt(input.value, 10) || min) + step;
    if (next < min) next = min;

    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ------------------------------------------------------------------ cart */

  function sectionsToRender() {
    var ids = [];
    if ($('#shopify-section-cart-drawer')) ids.push('cart-drawer');
    if ($('#shopify-section-main-cart')) ids.push('main-cart');
    return ids;
  }

  function updateCartCount(count) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.setAttribute('data-count', count);
    });
  }

  function replaceSection(id, html) {
    var target = document.getElementById('shopify-section-' + id);
    if (!target || !html) return;
    var parsed = new DOMParser().parseFromString(html, 'text/html');
    var fresh = parsed.getElementById('shopify-section-' + id);
    if (!fresh) return;
    var wasOpen = !!$('.drawer.is-open', target);
    target.innerHTML = fresh.innerHTML;
    if (wasOpen) {
      var drawer = $('.drawer', target);
      if (drawer) {
        drawer.hidden = false;
        drawer.classList.add('is-open');
        drawer.setAttribute('aria-hidden', 'false');
      }
    }
  }

  function applyCartResponse(data) {
    if (data && data.sections) {
      Object.keys(data.sections).forEach(function (id) {
        replaceSection(id, data.sections[id]);
      });
    }
    if (data && typeof data.item_count === 'number') {
      updateCartCount(data.item_count);
    } else {
      refreshCartCount();
    }
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: data }));
  }

  function refreshCartCount() {
    fetch(routes.cart + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        updateCartCount(cart.item_count);
      })
      .catch(function () {});
  }

  function showCartError(message, scope) {
    var target = scope ? $('[data-cart-error]', scope) : $('[data-cart-error]');
    if (!target) {
      if (message) window.alert(message);
      return;
    }
    target.textContent = message || '';
    target.hidden = !message;
  }

  function addToCart(payload, options) {
    options = options || {};
    var sections = sectionsToRender();

    return fetch(routes.cartAdd, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(
        Object.assign({}, payload, {
          sections: sections.join(','),
          sections_url: window.location.pathname
        })
      )
    })
      .then(function (response) {
        return response.json().then(function (data) {
          return { ok: response.ok, data: data };
        });
      })
      .then(function (result) {
        if (!result.ok) {
          showCartError(result.data.description || result.data.message, options.scope);
          throw new Error(result.data.description || 'Add to cart failed');
        }
        showCartError('', options.scope);
        applyCartResponse(result.data);
        if (EN.cartType === 'drawer' && $('#CartDrawer')) {
          openDrawer('CartDrawer');
        } else if (options.redirect !== false && EN.cartType !== 'drawer') {
          window.location.href = routes.cart;
        }
        return result.data;
      });
  }

  window.ENCart = { add: addToCart };

  /* Product forms */
  document.addEventListener('submit', function (event) {
    var form = event.target.closest('form.js-product-form');
    if (!form) return;
    if (EN.cartType !== 'drawer' && !form.hasAttribute('data-ajax')) return;

    event.preventDefault();
    var button = $('[data-add-button]', form) || $('button[type="submit"]', form);
    var formData = new FormData(form);
    var payload = { items: [{}] };

    payload.items[0].id = formData.get('id');
    payload.items[0].quantity = parseInt(formData.get('quantity') || '1', 10);

    var properties = {};
    formData.forEach(function (value, key) {
      var match = key.match(/^properties\[(.+)\]$/);
      if (match && value) properties[match[1]] = value;
    });
    if (Object.keys(properties).length) payload.items[0].properties = properties;

    var sellingPlan = formData.get('selling_plan');
    if (sellingPlan) payload.items[0].selling_plan = sellingPlan;

    if (button) button.classList.add('is-loading');

    addToCart(payload, { scope: form })
      .catch(function () {})
      .then(function () {
        if (button) button.classList.remove('is-loading');
      });
  });

  /* Quick add buttons (no form) */
  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-quick-add]');
    if (!btn) return;
    event.preventDefault();

    var id = btn.getAttribute('data-quick-add');
    if (!id) return;

    btn.classList.add('is-loading');
    addToCart({ items: [{ id: id, quantity: 1 }] })
      .catch(function () {})
      .then(function () {
        btn.classList.remove('is-loading');
      });
  });

  /* Cart line quantity + remove */
  function changeCartLine(line, quantity, row) {
    if (row) row.classList.add('is-updating');

    return fetch(routes.cartChange, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        line: line,
        quantity: quantity,
        sections: sectionsToRender().join(','),
        sections_url: window.location.pathname
      })
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (data) {
        applyCartResponse(data);
      })
      .catch(function () {
        if (row) row.classList.remove('is-updating');
      });
  }

  document.addEventListener('change', function (event) {
    var input = event.target.closest('[data-cart-qty]');
    if (!input) return;
    var row = input.closest('[data-cart-line]');
    var line = input.getAttribute('data-line');
    changeCartLine(line, parseInt(input.value, 10) || 0, row);
  });

  document.addEventListener('click', function (event) {
    var remove = event.target.closest('[data-cart-remove]');
    if (!remove) return;
    event.preventDefault();
    var row = remove.closest('[data-cart-line]');
    changeCartLine(remove.getAttribute('data-cart-remove'), 0, row);
  });

  /* Cart note */
  var saveNote = debounce(function (value) {
    fetch(routes.cartUpdate, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ note: value })
    });
  }, 600);

  document.addEventListener('input', function (event) {
    if (!event.target.matches('[data-cart-note]')) return;
    saveNote(event.target.value);
  });

  /* ------------------------------------------------------- variant picker */

  function initVariantPickers(root) {
    $$('[data-variant-picker]', root || document).forEach(function (picker) {
      if (picker.dataset.bound === 'true') return;
      picker.dataset.bound = 'true';

      var sectionId = picker.getAttribute('data-section');
      var dataEl = document.getElementById('VariantData-' + sectionId);
      if (!dataEl) return;

      var variants;
      try {
        variants = JSON.parse(dataEl.textContent);
      } catch (e) {
        return;
      }

      picker.addEventListener('change', function () {
        var selected = $$('input:checked, select', picker).map(function (el) {
          return el.value;
        });

        var match = variants.find(function (variant) {
          return variant.options.every(function (option, index) {
            return option === selected[index];
          });
        });

        updateSelectedOptionLabels(picker);
        applyVariant(sectionId, match, picker);
      });
    });
  }

  function updateSelectedOptionLabels(picker) {
    $$('.variant-group', picker).forEach(function (group) {
      var out = $('[data-selected-value]', group);
      var checked = $('input:checked', group) || $('select', group);
      if (out && checked) {
        out.textContent = checked.getAttribute('data-value') || checked.value;
      }
    });
  }

  function applyVariant(sectionId, variant, picker) {
    var scope = document.getElementById('ProductInfo-' + sectionId) || document;
    var idInput = $('[data-variant-id]', scope);
    var priceEl = $('[data-price-target]', scope);
    var button = $('[data-add-button]', scope);
    var buttonText = button ? $('[data-add-button-text]', button) : null;
    var skuEl = $('[data-sku]', scope);
    var inventoryEl = $('[data-inventory]', scope);

    if (!variant) {
      if (button) {
        button.setAttribute('disabled', 'disabled');
        if (buttonText) buttonText.textContent = EN.strings.unavailable;
      }
      return;
    }

    if (idInput) idInput.value = variant.id;

    if (priceEl) {
      var html = '<span class="price__current">' + formatMoney(variant.price) + '</span>';
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        html += ' <s class="price__compare">' + formatMoney(variant.compare_at_price) + '</s>';
      }
      priceEl.innerHTML = html;
      priceEl.classList.toggle(
        'price--on-sale',
        !!(variant.compare_at_price && variant.compare_at_price > variant.price)
      );
    }

    if (skuEl) skuEl.textContent = variant.sku || '';

    if (inventoryEl) {
      inventoryEl.textContent = variant.available
        ? inventoryEl.getAttribute('data-in-stock') || 'In stock'
        : inventoryEl.getAttribute('data-out-of-stock') || 'Out of stock';
    }

    if (button) {
      if (variant.available) {
        button.removeAttribute('disabled');
        if (buttonText) buttonText.textContent = EN.strings.addToCart;
      } else {
        button.setAttribute('disabled', 'disabled');
        if (buttonText) buttonText.textContent = EN.strings.soldOut;
      }
    }

    if (variant.featured_media_id) {
      selectGalleryMedia(sectionId, variant.featured_media_id);
    }

    if (window.history.replaceState && picker && picker.hasAttribute('data-update-url')) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }
  }

  function selectGalleryMedia(sectionId, mediaId) {
    var gallery = document.getElementById('Gallery-' + sectionId);
    if (!gallery) return;
    var thumb = $('[data-media-id="' + mediaId + '"]', gallery);
    if (thumb) thumb.click();
  }

  /* ---------------------------------------------------------- product media */

  function initGalleries(root) {
    $$('[data-gallery]', root || document).forEach(function (gallery) {
      if (gallery.dataset.bound === 'true') return;
      gallery.dataset.bound = 'true';

      gallery.addEventListener('click', function (event) {
        var thumb = event.target.closest('[data-media-id]');
        if (!thumb) return;
        event.preventDefault();

        var main = $('[data-gallery-main]', gallery);
        var src = thumb.getAttribute('data-full');
        var srcset = thumb.getAttribute('data-srcset');
        var alt = thumb.getAttribute('data-alt') || '';
        var img = main ? $('img', main) : null;

        if (img && src) {
          img.setAttribute('src', src);
          if (srcset) img.setAttribute('srcset', srcset);
          img.setAttribute('alt', alt);
        }

        $$('[data-media-id]', gallery).forEach(function (el) {
          el.classList.toggle('is-active', el === thumb);
        });
      });
    });
  }

  /* ------------------------------------------------------ collection facets */

  function initFacets(root) {
    $$('[data-facets-form]', root || document).forEach(function (form) {
      if (form.dataset.bound === 'true') return;
      form.dataset.bound = 'true';

      form.addEventListener('change', function () {
        if (form.hasAttribute('data-no-auto-submit')) return;
        form.submit();
      });
    });

    $$('[data-sort-select]', root || document).forEach(function (select) {
      if (select.dataset.bound === 'true') return;
      select.dataset.bound = 'true';

      select.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', select.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    });
  }

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-facets-toggle]');
    if (!toggle) return;
    event.preventDefault();
    var panel = $('[data-facets-panel]');
    if (!panel) return;
    var open = panel.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  /* ---------------------------------------------------------------- reveal */

  function initReveal(root) {
    var items = $$('.reveal:not(.is-visible)', root || document);
    if (!items.length) return;

    if (!('IntersectionObserver' in window)) {
      items.forEach(function (el) {
        el.classList.add('is-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.05 }
    );

    items.forEach(function (el, index) {
      el.style.transitionDelay = Math.min(index % 6, 5) * 60 + 'ms';
      observer.observe(el);
    });
  }

  /* -------------------------------------------------------- keyboard menus */

  function initNavKeyboard(root) {
    $$('[data-nav-item]', root || document).forEach(function (item) {
      if (item.dataset.bound === 'true') return;
      item.dataset.bound = 'true';

      item.addEventListener('keydown', function (event) {
        if (event.key !== 'Escape') return;
        var link = $('.nav__link', item);
        if (link) link.focus();
      });
    });
  }

  /* ------------------------------------------------------------------ init */

  function init(root) {
    initVariantPickers(root);
    initGalleries(root);
    initFacets(root);
    initReveal(root);
    initNavKeyboard(root);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initStickyHeader();
    init(document);
  });

  if (document.readyState !== 'loading') {
    initStickyHeader();
    init(document);
  }

  /* Theme editor support */
  document.addEventListener('shopify:section:load', function (event) {
    initStickyHeader();
    init(event.target);
  });

  document.addEventListener('shopify:section:select', function (event) {
    var drawer = $('.drawer', event.target);
    if (drawer && drawer.id) openDrawer(drawer.id);
  });

  document.addEventListener('shopify:section:deselect', function (event) {
    var drawer = $('.drawer', event.target);
    if (drawer && drawer.id) closeDrawer(drawer.id);
  });
})();
